module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av594-a3494cbeead392663d6aa08060c72c9e.jpg";